import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

const AuthContext = createContext({
  user: null,
  loading: true,
  login: () => {},
  logout: () => {},
  persistUser: () => {}
});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // محاولة استعادة بيانات المستخدم من التخزين المحلي عند بدء التطبيق
    const savedUser = localStorage.getItem('zed_user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // إعداد مراقب حالة المصادقة
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        // إذا كان المستخدم مسجل في Firebase، نحفظ بياناته
        const userData = {
          id: firebaseUser.uid,
          email: firebaseUser.email,
          // أي بيانات إضافية تريد حفظها
        };
        setUser(userData);
        localStorage.setItem('zed_user', JSON.stringify(userData));
      } else {
        // إذا لم يكن هناك مستخدم، نحاول استعادة البيانات من التخزين المحلي
        const savedUser = localStorage.getItem('zed_user');
        if (savedUser) {
          setUser(JSON.parse(savedUser));
        } else {
          setUser(null);
        }
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('zed_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('zed_user');
  };

  const value = {
    user,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
